const toggleDrawerBtns = document.querySelectorAll('.js-toggle-drawer');
const siteBody = document.body;

toggleDrawerBtns.forEach(btn=>{
    
    btn.addEventListener('click', ()=>{
        toggleDrawer(btn.dataset.target, btn);
        
    })
    document.querySelector('#' + btn.dataset.target).addEventListener('mouseleave', ()=>{
        toggleDrawer(btn.dataset.target, btn)
    })  
})

function toggleDrawer(targetID,btn) {
    btn.classList.toggle('mega-btn--active');
    let targetDrawer = document.querySelector('#' + targetID);
    targetDrawer.classList.toggle('drawer--expanded');
    siteBody.classList.toggle('scroll--blocked');
}
